import getExerciseTypeVersionAdapter from './adapters';
import definitions from './definitions';
export * from './definitions';
export * from './interfaces';
export * from './flavors';
export var hasTypeDefinitions = function hasTypeDefinitions(type) {
  return type in definitions;
};
export var hasVersionDefinition = function hasVersionDefinition(type, version) {
  return version in definitions[type];
};

// not possible yet to make this a combined type guard
export var hasSchemaDefinition = function hasSchemaDefinition(type, version) {
  if (!hasTypeDefinitions(type)) {
    return false;
  }
  return hasVersionDefinition(type, version);
};
export var getSchemaDefinition = function getSchemaDefinition(type, version) {
  if (!hasTypeDefinitions(type)) {
    throw new TypeError("Type '".concat(type, "' does not exist."));
  }
  if (!hasVersionDefinition(type, version)) {
    throw new TypeError("Version '".concat(version, "' of type '").concat(type, "' does not exist."));
  }
  return definitions[type][version];
};
export var LATEST_SCHEMA_VERSION = {
  ChatExercise: 'v1',
  CloudExercise: 'v1',
  DragAndDropExercise: 'v2',
  ExplorableExercise: 'v2',
  GpuExercise: 'v0',
  IDEExercise: 'v2',
  PureMultipleChoiceExercise: 'v3',
  RemoteDesktopExercise: 'v5',
  VideoExercise: 'v1',
  VisualExercise: 'v1'
};
export var getLatestSchemaVersion = function getLatestSchemaVersion(type) {
  return LATEST_SCHEMA_VERSION[type];
};
export var isLatestSchemaVersion = function isLatestSchemaVersion(type, version) {
  return getLatestSchemaVersion(type) === version;
};
export var migrateToLatestVersion = function migrateToLatestVersion(type, version, data) {
  return getExerciseTypeVersionAdapter(type, getLatestSchemaVersion(type))(type, version, data);
};
export var isInitialSchemaVersion = function isInitialSchemaVersion(type, version) {
  return version === 'v0';
};
export { getExerciseTypeVersionAdapter };